<div
  *ngIf="unsavedChangesService.hasChanges$ | async"
  class="d-flex justify-content-end align-items-center flex-row-reverse flex-sm-row"
>
  <span class="d-none d-xl-inline text-muted mr-2" i18n="@@shared.gridWrapper.txtThereAreUnsavedChanges">
    There are unsaved changes
  </span>
  <span class="d-xl-none text-muted mx-2" i18n="@@shared.gridWrapper.txtUnsavedChanges">Unsaved changes</span>
  <button
    data-testId="save-changes"
    mat-flat-button
    color="success"
    class="qa-btn-save-changes"
    (click)="unsavedChangesService.onSave()"
  >
    <mat-icon svgIcon="content-save"></mat-icon>
    <span class="d-none d-lg-inline" i18n="@@shared.gridWrapper.btnSaveChanges">Save changes</span>
    <span class="d-lg-none" i18n="@@shared.gridWrapper.btnSave">Save</span>
  </button>
</div>
